const isIOSUser = (userAgent: string) =>
  ['ios', 'iphone', 'ipad'].some((text) => userAgent.includes(text));

export const isMacOSUser = () => {
  const userAgent = window.navigator.userAgent;
  if (isIOSUser(userAgent)) return false;
  return userAgent.toLowerCase().includes('mac');
};
